import React, { PureComponent, Fragment } from 'react'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import McActions from 'store/redux/mc'
import { Row, Col, Form } from 'reactstrap'
import { FG, Button } from 'components'
import { translate } from 'react-i18next'
import { pageData } from 'decorators'
import { decimalRule, percentageRule } from 'utils/validation'
// import MOCK_TEMPLATE from 'data/mocks/mc/newGameTemplate.json'
import AdminTemplate from '../../templates/AdminTemplate'
import './NewGame.css'

@connect(
    state => {
        const { catalogue, discounts, healthRecovery } = state.mc.newGameTemplate
        const initialValues = {};
        ['engine', 'gearbox', 'wheels'].forEach(group => {
            (group === 'wheels' ? [1, 2, 3, 0] : [1, 2, 3]).forEach(number => {
                initialValues[`${group}${number}Name`] = catalogue[group][`${group}${number}`].name
                initialValues[`${group}${number}Shortname`] = catalogue[group][`${group}${number}`].shortname
                initialValues[`${group}${number}Description`] = catalogue[group][`${group}${number}`].description
                initialValues[`${group}${number}PMax`] = catalogue[group][`${group}${number}`].pmax
                initialValues[`${group}${number}AssetLife`] = catalogue[group][`${group}${number}`].assetLife
                initialValues[`${group}${number}Price`] = catalogue[group][`${group}${number}`].price
            })
        })
        initialValues.discountTwo = Math.round(discounts.two * 100)
        initialValues.discountThree = Math.round(discounts.three * 100)
        initialValues.healthRecoveryNoneLabel = healthRecovery.NONE.label
        initialValues.healthRecoveryNoneValue = 0
        initialValues.healthRecoveryLightLabel = healthRecovery.LIGHT.label
        initialValues.healthRecoveryLightValue = Math.round(healthRecovery.LIGHT.value * 100)
        initialValues.healthRecoveryMediumLabel = healthRecovery.MEDIUM.label
        initialValues.healthRecoveryMediumValue = Math.round(healthRecovery.MEDIUM.value * 100)
        initialValues.healthRecoveryHeavyLabel = healthRecovery.HEAVY.label
        initialValues.healthRecoveryHeavyValue = Math.round(healthRecovery.HEAVY.value * 100)
        initialValues.healthRecoveryReplaceLabel = healthRecovery.REPLACE.label
        initialValues.healthRecoveryReplaceValue = 100
        return {
            catalogue,
            discounts,
            healthRecovery,
            isLoading: state.global.loading,
            initialValues
        }
    },
    {
        save: McActions.newGameSaveStep2
    }
)
@reduxForm({ form: 'mcNewGameStep2' })
@pageData({ title: 'New Game (2/3)' })
@translate()
export class NewGameStep2 extends PureComponent {
    componentWillMount() {
        const { t } = this.props
        this.decimalRule = decimalRule(t)
        this.percentageRule = percentageRule(t)
    }
    onSubmit = form => {
        const { catalogue, save } = this.props
        const newCatalog = {};
        ['engine', 'gearbox', 'wheels'].forEach(group => {
            newCatalog[group] = {};
            (group === 'wheels' ? [1, 2, 3, 0] : [1, 2, 3]).forEach(number => {
                if (number === 0) {
                    newCatalog[group][`${group}${number}`] = {
                        ...catalogue[group][`${group}${number}`],
                        pmax: form[`${group}${number}PMax`],
                        assetLife: form[`${group}${number}AssetLife`],
                        price: form[`${group}${number}Price`]
                    }
                } else {
                    newCatalog[group][`${group}${number}`] = {
                        ...catalogue[group][`${group}${number}`],
                        name: form[`${group}${number}Name`],
                        shortname: form[`${group}${number}Shortname`],
                        description: form[`${group}${number}Description`],
                        pmax: form[`${group}${number}PMax`],
                        assetLife: form[`${group}${number}AssetLife`],
                        price: form[`${group}${number}Price`]
                    }
                }
            })
        })
        save({
            catalogue: newCatalog,
            discounts: {
                two: form.discountTwo / 100,
                three: form.discountThree / 100
            },
            healthRecovery: {
                NONE: { label: form.healthRecoveryNoneLabel, value: 0 },
                LIGHT: { label: form.healthRecoveryLightLabel, value: form.healthRecoveryLightValue / 100 },
                MEDIUM: { label: form.healthRecoveryMediumLabel, value: form.healthRecoveryMediumValue / 100 },
                HEAVY: { label: form.healthRecoveryHeavyLabel, value: form.healthRecoveryHeavyValue / 100 },
                REPLACE: { label: form.healthRecoveryReplaceLabel, value: 1 }
            }
        })
    }


    renderGroupOptions = group => {
        const { t } = this.props
        return (
            <Fragment key={group}>
                <h2>{t(`mc.newGame.step2.section.${group}`)}</h2>
                <Row>
                    {[1, 2, 3].map(number => this.renderOption(group, number))}
                </Row>
                {group === 'wheels' && (
                    <Row>
                        {this.renderOption(group, 0)}
                        <Col />
                        <Col />
                    </Row>
                )}
            </Fragment>
        )
    }
    renderOption = (group, number) => {
        const { catalogue, t } = this.props
        const isWheelsFIA = number === 0
        return (
            <Col key={number} className="flex-grow">
                {isWheelsFIA ? (
                    <Fragment>
                        <legend className="mt-3">{t('mc.newGame.step2.optionWheelsFIA.title')}</legend>
                        <p>{t('mc.newGame.step2.optionWheelsFIA.text')}</p>
                    </Fragment>
                ) : (
                        <Fragment>
                            <legend>{t('mc.newGame.step2.option', { number })}</legend>
                            {this.renderTextInput(`${group}${number}Name`, 'name')}
                            {this.renderTextInput(`${group}${number}Shortname`, 'shortname')}
                            {this.renderTextInput(`${group}${number}Description`, 'description')}
                        </Fragment>
                    )}
                {this.renderDecimalInput(`${group}${number}PMax`, 'performanceMax')}
                {this.renderDecimalInput(`${group}${number}AssetLife`, 'expectedAssetLife')}
                {this.renderDecimalInput(`${group}${number}Price`, 'price')}
            </Col>
        )
    }
    renderTextInput = (id, label) => {
        const { t } = this.props
        return (
            <FG.Text
                id={id}
                name={id}
                label={t(`mc.newGame.step2.${label}`)}
                required
                autoComplete="off"
            />
        )
    }
    renderDecimalInput = (id, label) => {
        const { t } = this.props
        return (
            <FG.Text
                type="text" // for Edge...
                id={id}
                name={id}
                label={t(`mc.newGame.step2.${label}`)}
                required
                autoComplete="off"
                validate={[this.decimalRule]}
            />
        )
    }
    renderPercentageInput = (id, label, disabled = false) => {
        const { t } = this.props
        return (
            <FG.Text
                type="number"
                id={id}
                name={id}
                label={t(`mc.newGame.step2.${label}`)}
                required={!disabled}
                disabled={disabled}
                min={0}
                max={100}
                autoComplete="off"
                validate={[this.percentageRule]}
            />
        )
    }

    render() {
        const { isLoading, handleSubmit, submitting, t } = this.props

        return (
            <AdminTemplate className="NewGame Step2 px-5" backRoute="/mc">
                <h1 dangerouslySetInnerHTML={{ __html: t('mc.newGame.step2.title') }} />
                <Form onSubmit={handleSubmit(this.onSubmit)} className="pb-5">

                    {['engine', 'gearbox', 'wheels'].map(this.renderGroupOptions)}

                    <h2>{t('mc.newGame.step2.section.discounts')}</h2>
                    <Row>
                        <Col>
                            {this.renderPercentageInput('discountTwo', 'discountTwo')}
                        </Col>
                        <Col>
                            {this.renderPercentageInput('discountThree', 'discountThree')}
                        </Col>
                    </Row>

                    <h2>{t('mc.newGame.step2.section.maintenance')}</h2>
                    <Row>
                        <Col>
                            {this.renderTextInput('healthRecoveryNoneLabel', 'healthRecoveryLabel')}
                        </Col>
                        <Col>
                            {this.renderPercentageInput('healthRecoveryNoneValue', 'healthRecoveryValue', true)}
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            {this.renderTextInput('healthRecoveryLightLabel', 'healthRecoveryLabel')}
                        </Col>
                        <Col>
                            {this.renderPercentageInput('healthRecoveryLightValue', 'healthRecoveryValue')}
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            {this.renderTextInput('healthRecoveryMediumLabel', 'healthRecoveryLabel')}
                        </Col>
                        <Col>
                            {this.renderPercentageInput('healthRecoveryMediumValue', 'healthRecoveryValue')}
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            {this.renderTextInput('healthRecoveryHeavyLabel', 'healthRecoveryLabel')}
                        </Col>
                        <Col>
                            {this.renderPercentageInput('healthRecoveryHeavyValue', 'healthRecoveryValue')}
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            {this.renderTextInput('healthRecoveryReplaceLabel', 'healthRecoveryLabel')}
                        </Col>
                        <Col>
                            {this.renderPercentageInput('healthRecoveryReplaceValue', 'healthRecoveryValue', true)}
                        </Col>
                    </Row>

                    <div className="Action-Btns">
                        <Button type="submit" color="primary" loading={isLoading} disabled={submitting}>
                            {t('mc.newGame.step2.nextBtn')}
                        </Button>
                    </div>
                </Form>
            </AdminTemplate>
        )
    }
}



// WEBPACK FOOTER //
// src/pages/MC/NewGame/NewGameStep2.js